import React from 'react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';

import DesktopNav from './DesktopNav';
import DrawerMenu from './DrawerMenu';
import BlueLogo from 'pcsgrades-logo-blue.inline.svg';
import MenuIcon from '../../assets/bars.inline.svg';

@inject('headerState')
@observer
class Header extends React.PureComponent {
  render() {
    return (
      <>
        <DrawerMenu />

        <div className="TopLineNav home-nav">
          <div className="nav-logo-container">
            <a href="/" aria-label="PCSgrades Homepage">
              <BlueLogo className="members-logo" />
            </a>
          </div>

          <DesktopNav />

          <div className="nav-menu-container-mobile">
            <MenuIcon
              className="vector-icon blue"
              onClick={this.handleDrawerToggle}
            />
          </div>
        </div>
      </>
    );
  }

  @action.bound
  handleDrawerToggle(_event) {
    this.props.headerState.toggleDrawer();
  }
}

export default Header;
